<template>
  <div>{{ currentTime }}</div>
</template>

<script>
export default {
  name: 'SystemTime',
  data () {
    return {
      currentTime: new Date().toISOString().slice(0, 19).replace('T', ' ')
    }
  },
  created () {
    this.updateTime()
  },
  methods: {
    updateTime () {
      setInterval(() => {
        this.currentTime = new Date().toISOString().slice(0, 19).replace('T', ' ')
      }, 1000)
    }
  }
}
</script>

<style scoped>
div {
  font-size: 0.875rem;
  padding: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SystemTime.vue